/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AcknowledgeMessageRequest,
    AcknowledgeMessageRequestFromJSON,
    AcknowledgeMessageRequestToJSON,
} from '../models/AcknowledgeMessageRequest';
import {
    type AddRecipientRequest,
    AddRecipientRequestFromJSON,
    AddRecipientRequestToJSON,
} from '../models/AddRecipientRequest';
import {
    type CaseActivityPageResponse,
    CaseActivityPageResponseFromJSON,
    CaseActivityPageResponseToJSON,
} from '../models/CaseActivityPageResponse';
import {
    type ChecklistTemplateResponse,
    ChecklistTemplateResponseFromJSON,
    ChecklistTemplateResponseToJSON,
} from '../models/ChecklistTemplateResponse';
import {
    type ConfirmVerificationDobRequest,
    ConfirmVerificationDobRequestFromJSON,
    ConfirmVerificationDobRequestToJSON,
} from '../models/ConfirmVerificationDobRequest';
import {
    type CreateRequestRequest,
    CreateRequestRequestFromJSON,
    CreateRequestRequestToJSON,
} from '../models/CreateRequestRequest';
import {
    type DocumentDownloadResponse,
    DocumentDownloadResponseFromJSON,
    DocumentDownloadResponseToJSON,
} from '../models/DocumentDownloadResponse';
import {
    type EmailPreviewResponse,
    EmailPreviewResponseFromJSON,
    EmailPreviewResponseToJSON,
} from '../models/EmailPreviewResponse';
import {
    type EnsureMedicaidCaseRequest,
    EnsureMedicaidCaseRequestFromJSON,
    EnsureMedicaidCaseRequestToJSON,
} from '../models/EnsureMedicaidCaseRequest';
import {
    type ExpectedRevisionRequest,
    ExpectedRevisionRequestFromJSON,
    ExpectedRevisionRequestToJSON,
} from '../models/ExpectedRevisionRequest';
import {
    type LeadMedicaidCaseResponse,
    LeadMedicaidCaseResponseFromJSON,
    LeadMedicaidCaseResponseToJSON,
} from '../models/LeadMedicaidCaseResponse';
import {
    type MedicaidCaseListPreset,
    MedicaidCaseListPresetFromJSON,
    MedicaidCaseListPresetToJSON,
} from '../models/MedicaidCaseListPreset';
import {
    type MedicaidCaseListResponse,
    MedicaidCaseListResponseFromJSON,
    MedicaidCaseListResponseToJSON,
} from '../models/MedicaidCaseListResponse';
import {
    type MedicaidCaseResponse,
    MedicaidCaseResponseFromJSON,
    MedicaidCaseResponseToJSON,
} from '../models/MedicaidCaseResponse';
import {
    type MedicaidCaseWorkspaceResponse,
    MedicaidCaseWorkspaceResponseFromJSON,
    MedicaidCaseWorkspaceResponseToJSON,
} from '../models/MedicaidCaseWorkspaceResponse';
import {
    type OptionalReasonRequest,
    OptionalReasonRequestFromJSON,
    OptionalReasonRequestToJSON,
} from '../models/OptionalReasonRequest';
import {
    type ParticipantInput,
    ParticipantInputFromJSON,
    ParticipantInputToJSON,
} from '../models/ParticipantInput';
import {
    type ParticipantLinkResponse,
    ParticipantLinkResponseFromJSON,
    ParticipantLinkResponseToJSON,
} from '../models/ParticipantLinkResponse';
import {
    type PortalAuthStartResponse,
    PortalAuthStartResponseFromJSON,
    PortalAuthStartResponseToJSON,
} from '../models/PortalAuthStartResponse';
import {
    type PortalDocumentListResponse,
    PortalDocumentListResponseFromJSON,
    PortalDocumentListResponseToJSON,
} from '../models/PortalDocumentListResponse';
import {
    type PortalDocumentResponse,
    PortalDocumentResponseFromJSON,
    PortalDocumentResponseToJSON,
} from '../models/PortalDocumentResponse';
import {
    type PortalErrorResponse,
    PortalErrorResponseFromJSON,
    PortalErrorResponseToJSON,
} from '../models/PortalErrorResponse';
import {
    type PortalExchangeRequest,
    PortalExchangeRequestFromJSON,
    PortalExchangeRequestToJSON,
} from '../models/PortalExchangeRequest';
import {
    type PortalItemResponseInput,
    PortalItemResponseInputFromJSON,
    PortalItemResponseInputToJSON,
} from '../models/PortalItemResponseInput';
import {
    type PortalLinkTokenRequest,
    PortalLinkTokenRequestFromJSON,
    PortalLinkTokenRequestToJSON,
} from '../models/PortalLinkTokenRequest';
import {
    type PortalLogoutResponse,
    PortalLogoutResponseFromJSON,
    PortalLogoutResponseToJSON,
} from '../models/PortalLogoutResponse';
import {
    type PortalMessageInput,
    PortalMessageInputFromJSON,
    PortalMessageInputToJSON,
} from '../models/PortalMessageInput';
import {
    type PortalMessagePageResponse,
    PortalMessagePageResponseFromJSON,
    PortalMessagePageResponseToJSON,
} from '../models/PortalMessagePageResponse';
import {
    type PortalMessageResponse,
    PortalMessageResponseFromJSON,
    PortalMessageResponseToJSON,
} from '../models/PortalMessageResponse';
import {
    type PortalPreviewResponse,
    PortalPreviewResponseFromJSON,
    PortalPreviewResponseToJSON,
} from '../models/PortalPreviewResponse';
import {
    type PortalRequestItemResponse,
    PortalRequestItemResponseFromJSON,
    PortalRequestItemResponseToJSON,
} from '../models/PortalRequestItemResponse';
import {
    type PortalRequestListResponse,
    PortalRequestListResponseFromJSON,
    PortalRequestListResponseToJSON,
} from '../models/PortalRequestListResponse';
import {
    type PortalSessionResponse,
    PortalSessionResponseFromJSON,
    PortalSessionResponseToJSON,
} from '../models/PortalSessionResponse';
import {
    type PortalUploadBatchRequest,
    PortalUploadBatchRequestFromJSON,
    PortalUploadBatchRequestToJSON,
} from '../models/PortalUploadBatchRequest';
import {
    type ReadCursorRequest,
    ReadCursorRequestFromJSON,
    ReadCursorRequestToJSON,
} from '../models/ReadCursorRequest';
import {
    type ReadCursorResponse,
    ReadCursorResponseFromJSON,
    ReadCursorResponseToJSON,
} from '../models/ReadCursorResponse';
import {
    type ReasonRequest,
    ReasonRequestFromJSON,
    ReasonRequestToJSON,
} from '../models/ReasonRequest';
import {
    type RejectDocumentRequest,
    RejectDocumentRequestFromJSON,
    RejectDocumentRequestToJSON,
} from '../models/RejectDocumentRequest';
import {
    type ReminderOverviewResponse,
    ReminderOverviewResponseFromJSON,
    ReminderOverviewResponseToJSON,
} from '../models/ReminderOverviewResponse';
import {
    type RenewAccessRequest,
    RenewAccessRequestFromJSON,
    RenewAccessRequestToJSON,
} from '../models/RenewAccessRequest';
import {
    type RequestItemInput,
    RequestItemInputFromJSON,
    RequestItemInputToJSON,
} from '../models/RequestItemInput';
import {
    type RevisionReasonRequest,
    RevisionReasonRequestFromJSON,
    RevisionReasonRequestToJSON,
} from '../models/RevisionReasonRequest';
import {
    type StaffDocumentPageResponse,
    StaffDocumentPageResponseFromJSON,
    StaffDocumentPageResponseToJSON,
} from '../models/StaffDocumentPageResponse';
import {
    type StaffDocumentResponse,
    StaffDocumentResponseFromJSON,
    StaffDocumentResponseToJSON,
} from '../models/StaffDocumentResponse';
import {
    type StaffErrorResponse,
    StaffErrorResponseFromJSON,
    StaffErrorResponseToJSON,
} from '../models/StaffErrorResponse';
import {
    type StaffMessageInput,
    StaffMessageInputFromJSON,
    StaffMessageInputToJSON,
} from '../models/StaffMessageInput';
import {
    type StaffMessagePageResponse,
    StaffMessagePageResponseFromJSON,
    StaffMessagePageResponseToJSON,
} from '../models/StaffMessagePageResponse';
import {
    type StaffMessageResponse,
    StaffMessageResponseFromJSON,
    StaffMessageResponseToJSON,
} from '../models/StaffMessageResponse';
import {
    type StaffParticipantResponse,
    StaffParticipantResponseFromJSON,
    StaffParticipantResponseToJSON,
} from '../models/StaffParticipantResponse';
import {
    type StaffRequestItemResponse,
    StaffRequestItemResponseFromJSON,
    StaffRequestItemResponseToJSON,
} from '../models/StaffRequestItemResponse';
import {
    type StaffRequestRecipientResponse,
    StaffRequestRecipientResponseFromJSON,
    StaffRequestRecipientResponseToJSON,
} from '../models/StaffRequestRecipientResponse';
import {
    type StaffRequestResponse,
    StaffRequestResponseFromJSON,
    StaffRequestResponseToJSON,
} from '../models/StaffRequestResponse';
import {
    type StaffUploadBatchRequest,
    StaffUploadBatchRequestFromJSON,
    StaffUploadBatchRequestToJSON,
} from '../models/StaffUploadBatchRequest';
import {
    type UpdateDocumentRequest,
    UpdateDocumentRequestFromJSON,
    UpdateDocumentRequestToJSON,
} from '../models/UpdateDocumentRequest';
import {
    type UpdateMedicaidCaseRequest,
    UpdateMedicaidCaseRequestFromJSON,
    UpdateMedicaidCaseRequestToJSON,
} from '../models/UpdateMedicaidCaseRequest';
import {
    type UpdateParticipantRequest,
    UpdateParticipantRequestFromJSON,
    UpdateParticipantRequestToJSON,
} from '../models/UpdateParticipantRequest';
import {
    type UpdateRequestItemRequest,
    UpdateRequestItemRequestFromJSON,
    UpdateRequestItemRequestToJSON,
} from '../models/UpdateRequestItemRequest';
import {
    type UpdateRequestRequest,
    UpdateRequestRequestFromJSON,
    UpdateRequestRequestToJSON,
} from '../models/UpdateRequestRequest';
import {
    type UploadBatchResponse,
    UploadBatchResponseFromJSON,
    UploadBatchResponseToJSON,
} from '../models/UploadBatchResponse';

export interface AcceptStaffMedicaidDocumentRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    documentId: string;
    /**
     * 
     */
    expectedRevisionRequest: ExpectedRevisionRequest;
}

export interface AcknowledgeMedicaidMessageRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    participantId: string;
    /**
     * 
     */
    messageId: string;
    /**
     * 
     */
    acknowledgeMessageRequest?: AcknowledgeMessageRequest;
}

export interface AddMedicaidParticipantRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    participantInput: ParticipantInput;
}

export interface AddMedicaidRequestItemRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    requestId: string;
    /**
     * 
     */
    requestItemInput: RequestItemInput;
}

export interface AddMedicaidRequestRecipientRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    requestId: string;
    /**
     * 
     */
    addRecipientRequest: AddRecipientRequest;
}

export interface ClearMedicaidItemResponseRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    itemId: string;
    /**
     * 
     */
    responseId: string;
    /**
     * 
     */
    optionalReasonRequest?: OptionalReasonRequest;
}

export interface CloseMedicaidCaseRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    revisionReasonRequest: RevisionReasonRequest;
}

export interface ConfirmMedicaidCaseVerificationDobRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    confirmVerificationDobRequest: ConfirmVerificationDobRequest;
}

export interface CreateMedicaidParticipantLinkRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    participantId: string;
    /**
     * 
     */
    body?: object;
}

export interface CreateMedicaidRequestRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    createRequestRequest: CreateRequestRequest;
}

export interface CreatePortalUploadBatchRequest {
    /**
     * 
     */
    portalUploadBatchRequest: PortalUploadBatchRequest;
}

export interface CreateStaffMedicaidUploadBatchRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    staffUploadBatchRequest: StaffUploadBatchRequest;
}

export interface EnsureMedicaidCaseOperationRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    ensureMedicaidCaseRequest?: EnsureMedicaidCaseRequest;
}

export interface ExchangePortalLinkRequest {
    /**
     * 
     */
    portalExchangeRequest: PortalExchangeRequest;
}

export interface FinalizePortalDocumentRequest {
    /**
     * 
     */
    documentId: string;
    /**
     * 
     */
    body?: object;
}

export interface FinalizeStaffMedicaidDocumentRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    documentId: string;
    /**
     * 
     */
    body?: object;
}

export interface GetLeadMedicaidCaseRequest {
    /**
     * 
     */
    leadId: string;
}

export interface GetMedicaidCaseWorkspaceRequest {
    /**
     * 
     */
    caseId: string;
}

export interface GetMedicaidChecklistTemplateRequest {
    /**
     * 
     */
    caseId: string;
}

export interface GetMedicaidParticipantPortalPreviewRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    participantId: string;
}

export interface GetMedicaidReminderOverviewRequest {
    /**
     * 
     */
    caseId: string;
}

export interface GetMedicaidRequestRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    requestId: string;
}

export interface GetMedicaidRequestEmailPreviewRequest {
    /**
     * 
     */
    participantId: string;
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    requestId: string;
}

export interface GetStaffMedicaidDocumentDownloadRequest {
    /**
     * 
     */
    filePosition: string;
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    documentId: string;
    /**
     * 
     */
    variant?: GetStaffMedicaidDocumentDownloadVariantEnum;
    /**
     * 
     */
    disposition?: GetStaffMedicaidDocumentDownloadDispositionEnum;
}

export interface ListMedicaidCaseActivityRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    cursor?: string;
    /**
     * 
     */
    limit?: string;
}

export interface ListMedicaidCasesRequest {
    /**
     * 
     */
    preset?: MedicaidCaseListPreset;
    /**
     * 
     */
    facilityId?: string;
    /**
     * 
     */
    ownerUserId?: string;
    /**
     * 
     */
    search?: string;
    /**
     * 
     */
    cursor?: string;
    /**
     * 
     */
    limit?: string;
}

export interface ListPortalMessagesRequest {
    /**
     * Return messages after this message id
     */
    after?: string;
    /**
     * Return messages before this message id
     */
    before?: string;
    /**
     * 
     */
    limit?: string;
}

export interface ListStaffMedicaidDocumentsRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    requestItemId?: string;
    /**
     * 
     */
    uncategorized?: ListStaffMedicaidDocumentsUncategorizedEnum;
    /**
     * 
     */
    cursor?: string;
    /**
     * 
     */
    limit?: string;
}

export interface ListStaffMedicaidMessagesRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    participantId: string;
    /**
     * Return messages after this message id
     */
    after?: string;
    /**
     * Return messages before this message id
     */
    before?: string;
    /**
     * 
     */
    limit?: string;
}

export interface LogoutPortalSessionRequest {
    /**
     * 
     */
    body?: object;
}

export interface PauseMedicaidRecipientRemindersRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    requestId: string;
    /**
     * 
     */
    recipientId: string;
    /**
     * 
     */
    optionalReasonRequest?: OptionalReasonRequest;
}

export interface RejectStaffMedicaidDocumentRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    documentId: string;
    /**
     * 
     */
    rejectDocumentRequest: RejectDocumentRequest;
}

export interface RemoveMedicaidRequestRecipientRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    requestId: string;
    /**
     * 
     */
    recipientId: string;
    /**
     * 
     */
    optionalReasonRequest?: OptionalReasonRequest;
}

export interface RenewMedicaidParticipantAccessRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    participantId: string;
    /**
     * 
     */
    renewAccessRequest: RenewAccessRequest;
}

export interface ReopenMedicaidCaseRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    revisionReasonRequest: RevisionReasonRequest;
}

export interface ResumeMedicaidRecipientRemindersRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    requestId: string;
    /**
     * 
     */
    recipientId: string;
    /**
     * 
     */
    body?: object;
}

export interface RevokeMedicaidParticipantAccessRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    participantId: string;
    /**
     * 
     */
    reasonRequest: ReasonRequest;
}

export interface SendMedicaidRecipientReminderRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    requestId: string;
    /**
     * 
     */
    recipientId: string;
    /**
     * 
     */
    body?: object;
}

export interface SendMedicaidRequestRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    requestId: string;
    /**
     * 
     */
    expectedRevisionRequest: ExpectedRevisionRequest;
}

export interface SendPortalMessageRequest {
    /**
     * 
     */
    portalMessageInput: PortalMessageInput;
}

export interface SendStaffMedicaidMessageRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    participantId: string;
    /**
     * 
     */
    staffMessageInput: StaffMessageInput;
}

export interface StartPortalAuthRequest {
    /**
     * 
     */
    portalLinkTokenRequest: PortalLinkTokenRequest;
}

export interface SubmitPortalItemResponseRequest {
    /**
     * 
     */
    itemId: string;
    /**
     * 
     */
    portalItemResponseInput: PortalItemResponseInput;
}

export interface UpdateMedicaidCaseOperationRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    updateMedicaidCaseRequest: UpdateMedicaidCaseRequest;
}

export interface UpdateMedicaidParticipantRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    participantId: string;
    /**
     * 
     */
    updateParticipantRequest: UpdateParticipantRequest;
}

export interface UpdateMedicaidRequestRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    requestId: string;
    /**
     * 
     */
    updateRequestRequest: UpdateRequestRequest;
}

export interface UpdateMedicaidRequestItemRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    itemId: string;
    /**
     * 
     */
    updateRequestItemRequest: UpdateRequestItemRequest;
}

export interface UpdatePortalReadCursorRequest {
    /**
     * 
     */
    readCursorRequest: ReadCursorRequest;
}

export interface UpdateStaffMedicaidDocumentRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    documentId: string;
    /**
     * 
     */
    updateDocumentRequest: UpdateDocumentRequest;
}

export interface WithdrawMedicaidRequestRequest {
    /**
     * 
     */
    caseId: string;
    /**
     * 
     */
    requestId: string;
    /**
     * 
     */
    revisionReasonRequest: RevisionReasonRequest;
}

export interface WithdrawPortalItemResponseRequest {
    /**
     * 
     */
    itemId: string;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Creates request options for acceptStaffMedicaidDocument without sending the request
     */
    async acceptStaffMedicaidDocumentRequestOpts(requestParameters: AcceptStaffMedicaidDocumentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling acceptStaffMedicaidDocument().'
            );
        }

        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling acceptStaffMedicaidDocument().'
            );
        }

        if (requestParameters['expectedRevisionRequest'] == null) {
            throw new runtime.RequiredError(
                'expectedRevisionRequest',
                'Required parameter "expectedRevisionRequest" was null or undefined when calling acceptStaffMedicaidDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/medicaid-cases/{caseId}/documents/{documentId}/accept`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace('{documentId}', encodeURIComponent(String(requestParameters['documentId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExpectedRevisionRequestToJSON(requestParameters['expectedRevisionRequest']),
        };
    }

    /**
     * Accept a ready document
     */
    async acceptStaffMedicaidDocumentRaw(requestParameters: AcceptStaffMedicaidDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StaffDocumentResponse>> {
        const requestOptions = await this.acceptStaffMedicaidDocumentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StaffDocumentResponseFromJSON(jsonValue));
    }

    /**
     * Accept a ready document
     */
    async acceptStaffMedicaidDocument(requestParameters: AcceptStaffMedicaidDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StaffDocumentResponse> {
        const response = await this.acceptStaffMedicaidDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for acknowledgeMedicaidMessage without sending the request
     */
    async acknowledgeMedicaidMessageRequestOpts(requestParameters: AcknowledgeMedicaidMessageRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling acknowledgeMedicaidMessage().'
            );
        }

        if (requestParameters['participantId'] == null) {
            throw new runtime.RequiredError(
                'participantId',
                'Required parameter "participantId" was null or undefined when calling acknowledgeMedicaidMessage().'
            );
        }

        if (requestParameters['messageId'] == null) {
            throw new runtime.RequiredError(
                'messageId',
                'Required parameter "messageId" was null or undefined when calling acknowledgeMedicaidMessage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/medicaid-cases/{caseId}/participants/{participantId}/messages/{messageId}/acknowledge`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace('{participantId}', encodeURIComponent(String(requestParameters['participantId'])));
        urlPath = urlPath.replace('{messageId}', encodeURIComponent(String(requestParameters['messageId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AcknowledgeMessageRequestToJSON(requestParameters['acknowledgeMessageRequest']),
        };
    }

    /**
     * Mark a participant message as handled without replying
     */
    async acknowledgeMedicaidMessageRaw(requestParameters: AcknowledgeMedicaidMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StaffMessageResponse>> {
        const requestOptions = await this.acknowledgeMedicaidMessageRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StaffMessageResponseFromJSON(jsonValue));
    }

    /**
     * Mark a participant message as handled without replying
     */
    async acknowledgeMedicaidMessage(requestParameters: AcknowledgeMedicaidMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StaffMessageResponse> {
        const response = await this.acknowledgeMedicaidMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for addMedicaidParticipant without sending the request
     */
    async addMedicaidParticipantRequestOpts(requestParameters: AddMedicaidParticipantRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling addMedicaidParticipant().'
            );
        }

        if (requestParameters['participantInput'] == null) {
            throw new runtime.RequiredError(
                'participantInput',
                'Required parameter "participantInput" was null or undefined when calling addMedicaidParticipant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/medicaid-cases/{caseId}/participants`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ParticipantInputToJSON(requestParameters['participantInput']),
        };
    }

    /**
     * Add a family member or representative
     */
    async addMedicaidParticipantRaw(requestParameters: AddMedicaidParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StaffParticipantResponse>> {
        const requestOptions = await this.addMedicaidParticipantRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StaffParticipantResponseFromJSON(jsonValue));
    }

    /**
     * Add a family member or representative
     */
    async addMedicaidParticipant(requestParameters: AddMedicaidParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StaffParticipantResponse> {
        const response = await this.addMedicaidParticipantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for addMedicaidRequestItem without sending the request
     */
    async addMedicaidRequestItemRequestOpts(requestParameters: AddMedicaidRequestItemRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling addMedicaidRequestItem().'
            );
        }

        if (requestParameters['requestId'] == null) {
            throw new runtime.RequiredError(
                'requestId',
                'Required parameter "requestId" was null or undefined when calling addMedicaidRequestItem().'
            );
        }

        if (requestParameters['requestItemInput'] == null) {
            throw new runtime.RequiredError(
                'requestItemInput',
                'Required parameter "requestItemInput" was null or undefined when calling addMedicaidRequestItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/medicaid-cases/{caseId}/requests/{requestId}/items`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace('{requestId}', encodeURIComponent(String(requestParameters['requestId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestItemInputToJSON(requestParameters['requestItemInput']),
        };
    }

    /**
     * Add a document to the checklist
     */
    async addMedicaidRequestItemRaw(requestParameters: AddMedicaidRequestItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StaffRequestItemResponse>> {
        const requestOptions = await this.addMedicaidRequestItemRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StaffRequestItemResponseFromJSON(jsonValue));
    }

    /**
     * Add a document to the checklist
     */
    async addMedicaidRequestItem(requestParameters: AddMedicaidRequestItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StaffRequestItemResponse> {
        const response = await this.addMedicaidRequestItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for addMedicaidRequestRecipient without sending the request
     */
    async addMedicaidRequestRecipientRequestOpts(requestParameters: AddMedicaidRequestRecipientRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling addMedicaidRequestRecipient().'
            );
        }

        if (requestParameters['requestId'] == null) {
            throw new runtime.RequiredError(
                'requestId',
                'Required parameter "requestId" was null or undefined when calling addMedicaidRequestRecipient().'
            );
        }

        if (requestParameters['addRecipientRequest'] == null) {
            throw new runtime.RequiredError(
                'addRecipientRequest',
                'Required parameter "addRecipientRequest" was null or undefined when calling addMedicaidRequestRecipient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/medicaid-cases/{caseId}/requests/{requestId}/recipients`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace('{requestId}', encodeURIComponent(String(requestParameters['requestId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddRecipientRequestToJSON(requestParameters['addRecipientRequest']),
        };
    }

    /**
     * Add a participant as a recipient of the request
     */
    async addMedicaidRequestRecipientRaw(requestParameters: AddMedicaidRequestRecipientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StaffRequestRecipientResponse>> {
        const requestOptions = await this.addMedicaidRequestRecipientRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StaffRequestRecipientResponseFromJSON(jsonValue));
    }

    /**
     * Add a participant as a recipient of the request
     */
    async addMedicaidRequestRecipient(requestParameters: AddMedicaidRequestRecipientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StaffRequestRecipientResponse> {
        const response = await this.addMedicaidRequestRecipientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for clearMedicaidItemResponse without sending the request
     */
    async clearMedicaidItemResponseRequestOpts(requestParameters: ClearMedicaidItemResponseRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling clearMedicaidItemResponse().'
            );
        }

        if (requestParameters['itemId'] == null) {
            throw new runtime.RequiredError(
                'itemId',
                'Required parameter "itemId" was null or undefined when calling clearMedicaidItemResponse().'
            );
        }

        if (requestParameters['responseId'] == null) {
            throw new runtime.RequiredError(
                'responseId',
                'Required parameter "responseId" was null or undefined when calling clearMedicaidItemResponse().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/medicaid-cases/{caseId}/items/{itemId}/responses/{responseId}/clear`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace('{itemId}', encodeURIComponent(String(requestParameters['itemId'])));
        urlPath = urlPath.replace('{responseId}', encodeURIComponent(String(requestParameters['responseId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OptionalReasonRequestToJSON(requestParameters['optionalReasonRequest']),
        };
    }

    /**
     * Clear a participant\'s \"I Don\'t Have This\" response and resume their reminders for the item
     */
    async clearMedicaidItemResponseRaw(requestParameters: ClearMedicaidItemResponseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StaffRequestItemResponse>> {
        const requestOptions = await this.clearMedicaidItemResponseRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StaffRequestItemResponseFromJSON(jsonValue));
    }

    /**
     * Clear a participant\'s \"I Don\'t Have This\" response and resume their reminders for the item
     */
    async clearMedicaidItemResponse(requestParameters: ClearMedicaidItemResponseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StaffRequestItemResponse> {
        const response = await this.clearMedicaidItemResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for closeMedicaidCase without sending the request
     */
    async closeMedicaidCaseRequestOpts(requestParameters: CloseMedicaidCaseRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling closeMedicaidCase().'
            );
        }

        if (requestParameters['revisionReasonRequest'] == null) {
            throw new runtime.RequiredError(
                'revisionReasonRequest',
                'Required parameter "revisionReasonRequest" was null or undefined when calling closeMedicaidCase().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/medicaid-cases/{caseId}/close`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RevisionReasonRequestToJSON(requestParameters['revisionReasonRequest']),
        };
    }

    /**
     * Close the case, revoke participant access and cancel pending sends
     */
    async closeMedicaidCaseRaw(requestParameters: CloseMedicaidCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicaidCaseResponse>> {
        const requestOptions = await this.closeMedicaidCaseRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MedicaidCaseResponseFromJSON(jsonValue));
    }

    /**
     * Close the case, revoke participant access and cancel pending sends
     */
    async closeMedicaidCase(requestParameters: CloseMedicaidCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MedicaidCaseResponse> {
        const response = await this.closeMedicaidCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for confirmMedicaidCaseVerificationDob without sending the request
     */
    async confirmMedicaidCaseVerificationDobRequestOpts(requestParameters: ConfirmMedicaidCaseVerificationDobRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling confirmMedicaidCaseVerificationDob().'
            );
        }

        if (requestParameters['confirmVerificationDobRequest'] == null) {
            throw new runtime.RequiredError(
                'confirmVerificationDobRequest',
                'Required parameter "confirmVerificationDobRequest" was null or undefined when calling confirmMedicaidCaseVerificationDob().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/medicaid-cases/{caseId}/verification-dob`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ConfirmVerificationDobRequestToJSON(requestParameters['confirmVerificationDobRequest']),
        };
    }

    /**
     * Confirm or enter the resident\'s date of birth that family members must match; required before sending
     */
    async confirmMedicaidCaseVerificationDobRaw(requestParameters: ConfirmMedicaidCaseVerificationDobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicaidCaseResponse>> {
        const requestOptions = await this.confirmMedicaidCaseVerificationDobRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MedicaidCaseResponseFromJSON(jsonValue));
    }

    /**
     * Confirm or enter the resident\'s date of birth that family members must match; required before sending
     */
    async confirmMedicaidCaseVerificationDob(requestParameters: ConfirmMedicaidCaseVerificationDobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MedicaidCaseResponse> {
        const response = await this.confirmMedicaidCaseVerificationDobRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createMedicaidParticipantLink without sending the request
     */
    async createMedicaidParticipantLinkRequestOpts(requestParameters: CreateMedicaidParticipantLinkRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling createMedicaidParticipantLink().'
            );
        }

        if (requestParameters['participantId'] == null) {
            throw new runtime.RequiredError(
                'participantId',
                'Required parameter "participantId" was null or undefined when calling createMedicaidParticipantLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/medicaid-cases/{caseId}/participants/{participantId}/link`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace('{participantId}', encodeURIComponent(String(requestParameters['participantId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        };
    }

    /**
     * Copy Link; mints a new portal link for the participant and returns its URL once
     */
    async createMedicaidParticipantLinkRaw(requestParameters: CreateMedicaidParticipantLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ParticipantLinkResponse>> {
        const requestOptions = await this.createMedicaidParticipantLinkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ParticipantLinkResponseFromJSON(jsonValue));
    }

    /**
     * Copy Link; mints a new portal link for the participant and returns its URL once
     */
    async createMedicaidParticipantLink(requestParameters: CreateMedicaidParticipantLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ParticipantLinkResponse> {
        const response = await this.createMedicaidParticipantLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createMedicaidRequest without sending the request
     */
    async createMedicaidRequestRequestOpts(requestParameters: CreateMedicaidRequestRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling createMedicaidRequest().'
            );
        }

        if (requestParameters['createRequestRequest'] == null) {
            throw new runtime.RequiredError(
                'createRequestRequest',
                'Required parameter "createRequestRequest" was null or undefined when calling createMedicaidRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/medicaid-cases/{caseId}/requests`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateRequestRequestToJSON(requestParameters['createRequestRequest']),
        };
    }

    /**
     * Create a draft request with its checklist items and recipients
     */
    async createMedicaidRequestRaw(requestParameters: CreateMedicaidRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StaffRequestResponse>> {
        const requestOptions = await this.createMedicaidRequestRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StaffRequestResponseFromJSON(jsonValue));
    }

    /**
     * Create a draft request with its checklist items and recipients
     */
    async createMedicaidRequest(requestParameters: CreateMedicaidRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StaffRequestResponse> {
        const response = await this.createMedicaidRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createPortalUploadBatch without sending the request
     */
    async createPortalUploadBatchRequestOpts(requestParameters: CreatePortalUploadBatchRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['portalUploadBatchRequest'] == null) {
            throw new runtime.RequiredError(
                'portalUploadBatchRequest',
                'Required parameter "portalUploadBatchRequest" was null or undefined when calling createPortalUploadBatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/portal/upload-batches`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PortalUploadBatchRequestToJSON(requestParameters['portalUploadBatchRequest']),
        };
    }

    /**
     * Create upload intents and receive 15-minute presigned PUT targets
     */
    async createPortalUploadBatchRaw(requestParameters: CreatePortalUploadBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadBatchResponse>> {
        const requestOptions = await this.createPortalUploadBatchRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadBatchResponseFromJSON(jsonValue));
    }

    /**
     * Create upload intents and receive 15-minute presigned PUT targets
     */
    async createPortalUploadBatch(requestParameters: CreatePortalUploadBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadBatchResponse> {
        const response = await this.createPortalUploadBatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createStaffMedicaidUploadBatch without sending the request
     */
    async createStaffMedicaidUploadBatchRequestOpts(requestParameters: CreateStaffMedicaidUploadBatchRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling createStaffMedicaidUploadBatch().'
            );
        }

        if (requestParameters['staffUploadBatchRequest'] == null) {
            throw new runtime.RequiredError(
                'staffUploadBatchRequest',
                'Required parameter "staffUploadBatchRequest" was null or undefined when calling createStaffMedicaidUploadBatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/medicaid-cases/{caseId}/upload-batches`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StaffUploadBatchRequestToJSON(requestParameters['staffUploadBatchRequest']),
        };
    }

    /**
     * Upload From; staff upload of documents received by portal, fax, email, mail or in person
     */
    async createStaffMedicaidUploadBatchRaw(requestParameters: CreateStaffMedicaidUploadBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadBatchResponse>> {
        const requestOptions = await this.createStaffMedicaidUploadBatchRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadBatchResponseFromJSON(jsonValue));
    }

    /**
     * Upload From; staff upload of documents received by portal, fax, email, mail or in person
     */
    async createStaffMedicaidUploadBatch(requestParameters: CreateStaffMedicaidUploadBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadBatchResponse> {
        const response = await this.createStaffMedicaidUploadBatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for ensureMedicaidCase without sending the request
     */
    async ensureMedicaidCaseRequestOpts(requestParameters: EnsureMedicaidCaseOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling ensureMedicaidCase().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{leadId}/medicaid-cases`;
        urlPath = urlPath.replace('{leadId}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EnsureMedicaidCaseRequestToJSON(requestParameters['ensureMedicaidCaseRequest']),
        };
    }

    /**
     * Create or return the lead\'s one active Medicaid Pending case
     */
    async ensureMedicaidCaseRaw(requestParameters: EnsureMedicaidCaseOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicaidCaseResponse>> {
        const requestOptions = await this.ensureMedicaidCaseRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MedicaidCaseResponseFromJSON(jsonValue));
    }

    /**
     * Create or return the lead\'s one active Medicaid Pending case
     */
    async ensureMedicaidCase(requestParameters: EnsureMedicaidCaseOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MedicaidCaseResponse> {
        const response = await this.ensureMedicaidCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for exchangePortalLink without sending the request
     */
    async exchangePortalLinkRequestOpts(requestParameters: ExchangePortalLinkRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['portalExchangeRequest'] == null) {
            throw new runtime.RequiredError(
                'portalExchangeRequest',
                'Required parameter "portalExchangeRequest" was null or undefined when calling exchangePortalLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/portal/auth/exchange`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PortalExchangeRequestToJSON(requestParameters['portalExchangeRequest']),
        };
    }

    /**
     * Exchange a link token and the resident\'s date of birth for a session cookie
     */
    async exchangePortalLinkRaw(requestParameters: ExchangePortalLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortalSessionResponse>> {
        const requestOptions = await this.exchangePortalLinkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortalSessionResponseFromJSON(jsonValue));
    }

    /**
     * Exchange a link token and the resident\'s date of birth for a session cookie
     */
    async exchangePortalLink(requestParameters: ExchangePortalLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortalSessionResponse> {
        const response = await this.exchangePortalLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for finalizePortalDocument without sending the request
     */
    async finalizePortalDocumentRequestOpts(requestParameters: FinalizePortalDocumentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling finalizePortalDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/portal/documents/{documentId}/finalize`;
        urlPath = urlPath.replace('{documentId}', encodeURIComponent(String(requestParameters['documentId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        };
    }

    /**
     * Confirm the upload finished and start processing
     */
    async finalizePortalDocumentRaw(requestParameters: FinalizePortalDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortalDocumentResponse>> {
        const requestOptions = await this.finalizePortalDocumentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortalDocumentResponseFromJSON(jsonValue));
    }

    /**
     * Confirm the upload finished and start processing
     */
    async finalizePortalDocument(requestParameters: FinalizePortalDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortalDocumentResponse> {
        const response = await this.finalizePortalDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for finalizeStaffMedicaidDocument without sending the request
     */
    async finalizeStaffMedicaidDocumentRequestOpts(requestParameters: FinalizeStaffMedicaidDocumentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling finalizeStaffMedicaidDocument().'
            );
        }

        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling finalizeStaffMedicaidDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/medicaid-cases/{caseId}/documents/{documentId}/finalize`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace('{documentId}', encodeURIComponent(String(requestParameters['documentId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        };
    }

    /**
     * Confirm a staff upload finished and start processing
     */
    async finalizeStaffMedicaidDocumentRaw(requestParameters: FinalizeStaffMedicaidDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StaffDocumentResponse>> {
        const requestOptions = await this.finalizeStaffMedicaidDocumentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StaffDocumentResponseFromJSON(jsonValue));
    }

    /**
     * Confirm a staff upload finished and start processing
     */
    async finalizeStaffMedicaidDocument(requestParameters: FinalizeStaffMedicaidDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StaffDocumentResponse> {
        const response = await this.finalizeStaffMedicaidDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getLeadMedicaidCase without sending the request
     */
    async getLeadMedicaidCaseRequestOpts(requestParameters: GetLeadMedicaidCaseRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling getLeadMedicaidCase().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{leadId}/medicaid-cases`;
        urlPath = urlPath.replace('{leadId}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The lead\'s active Medicaid Pending case, if any
     */
    async getLeadMedicaidCaseRaw(requestParameters: GetLeadMedicaidCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LeadMedicaidCaseResponse>> {
        const requestOptions = await this.getLeadMedicaidCaseRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LeadMedicaidCaseResponseFromJSON(jsonValue));
    }

    /**
     * The lead\'s active Medicaid Pending case, if any
     */
    async getLeadMedicaidCase(requestParameters: GetLeadMedicaidCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LeadMedicaidCaseResponse> {
        const response = await this.getLeadMedicaidCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMedicaidCaseWorkspace without sending the request
     */
    async getMedicaidCaseWorkspaceRequestOpts(requestParameters: GetMedicaidCaseWorkspaceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling getMedicaidCaseWorkspace().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/medicaid-cases/{caseId}`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Gather view for the case, with participants, requests, items and the outreach summary
     */
    async getMedicaidCaseWorkspaceRaw(requestParameters: GetMedicaidCaseWorkspaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicaidCaseWorkspaceResponse>> {
        const requestOptions = await this.getMedicaidCaseWorkspaceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MedicaidCaseWorkspaceResponseFromJSON(jsonValue));
    }

    /**
     * Gather view for the case, with participants, requests, items and the outreach summary
     */
    async getMedicaidCaseWorkspace(requestParameters: GetMedicaidCaseWorkspaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MedicaidCaseWorkspaceResponse> {
        const response = await this.getMedicaidCaseWorkspaceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMedicaidChecklistTemplate without sending the request
     */
    async getMedicaidChecklistTemplateRequestOpts(requestParameters: GetMedicaidChecklistTemplateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling getMedicaidChecklistTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/medicaid-cases/{caseId}/checklist-template`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Starter checklist staff edit before creating a request
     */
    async getMedicaidChecklistTemplateRaw(requestParameters: GetMedicaidChecklistTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChecklistTemplateResponse>> {
        const requestOptions = await this.getMedicaidChecklistTemplateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChecklistTemplateResponseFromJSON(jsonValue));
    }

    /**
     * Starter checklist staff edit before creating a request
     */
    async getMedicaidChecklistTemplate(requestParameters: GetMedicaidChecklistTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChecklistTemplateResponse> {
        const response = await this.getMedicaidChecklistTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMedicaidParticipantPortalPreview without sending the request
     */
    async getMedicaidParticipantPortalPreviewRequestOpts(requestParameters: GetMedicaidParticipantPortalPreviewRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling getMedicaidParticipantPortalPreview().'
            );
        }

        if (requestParameters['participantId'] == null) {
            throw new runtime.RequiredError(
                'participantId',
                'Required parameter "participantId" was null or undefined when calling getMedicaidParticipantPortalPreview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/medicaid-cases/{caseId}/participants/{participantId}/portal-preview`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace('{participantId}', encodeURIComponent(String(requestParameters['participantId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Preview Family View; the portal payload exactly as this participant sees it
     */
    async getMedicaidParticipantPortalPreviewRaw(requestParameters: GetMedicaidParticipantPortalPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortalPreviewResponse>> {
        const requestOptions = await this.getMedicaidParticipantPortalPreviewRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortalPreviewResponseFromJSON(jsonValue));
    }

    /**
     * Preview Family View; the portal payload exactly as this participant sees it
     */
    async getMedicaidParticipantPortalPreview(requestParameters: GetMedicaidParticipantPortalPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortalPreviewResponse> {
        const response = await this.getMedicaidParticipantPortalPreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMedicaidReminderOverview without sending the request
     */
    async getMedicaidReminderOverviewRequestOpts(requestParameters: GetMedicaidReminderOverviewRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling getMedicaidReminderOverview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/medicaid-cases/{caseId}/reminders`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Reminder settings, next sends and outreach history for every request on the case
     */
    async getMedicaidReminderOverviewRaw(requestParameters: GetMedicaidReminderOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReminderOverviewResponse>> {
        const requestOptions = await this.getMedicaidReminderOverviewRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReminderOverviewResponseFromJSON(jsonValue));
    }

    /**
     * Reminder settings, next sends and outreach history for every request on the case
     */
    async getMedicaidReminderOverview(requestParameters: GetMedicaidReminderOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReminderOverviewResponse> {
        const response = await this.getMedicaidReminderOverviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMedicaidRequest without sending the request
     */
    async getMedicaidRequestRequestOpts(requestParameters: GetMedicaidRequestRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling getMedicaidRequest().'
            );
        }

        if (requestParameters['requestId'] == null) {
            throw new runtime.RequiredError(
                'requestId',
                'Required parameter "requestId" was null or undefined when calling getMedicaidRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/medicaid-cases/{caseId}/requests/{requestId}`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace('{requestId}', encodeURIComponent(String(requestParameters['requestId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Request with its items and recipients
     */
    async getMedicaidRequestRaw(requestParameters: GetMedicaidRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StaffRequestResponse>> {
        const requestOptions = await this.getMedicaidRequestRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StaffRequestResponseFromJSON(jsonValue));
    }

    /**
     * Request with its items and recipients
     */
    async getMedicaidRequest(requestParameters: GetMedicaidRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StaffRequestResponse> {
        const response = await this.getMedicaidRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMedicaidRequestEmailPreview without sending the request
     */
    async getMedicaidRequestEmailPreviewRequestOpts(requestParameters: GetMedicaidRequestEmailPreviewRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['participantId'] == null) {
            throw new runtime.RequiredError(
                'participantId',
                'Required parameter "participantId" was null or undefined when calling getMedicaidRequestEmailPreview().'
            );
        }

        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling getMedicaidRequestEmailPreview().'
            );
        }

        if (requestParameters['requestId'] == null) {
            throw new runtime.RequiredError(
                'requestId',
                'Required parameter "requestId" was null or undefined when calling getMedicaidRequestEmailPreview().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['participantId'] != null) {
            queryParameters['participant_id'] = requestParameters['participantId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/medicaid-cases/{caseId}/requests/{requestId}/email-preview`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace('{requestId}', encodeURIComponent(String(requestParameters['requestId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Render the invitation email for one recipient without sending it
     */
    async getMedicaidRequestEmailPreviewRaw(requestParameters: GetMedicaidRequestEmailPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmailPreviewResponse>> {
        const requestOptions = await this.getMedicaidRequestEmailPreviewRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmailPreviewResponseFromJSON(jsonValue));
    }

    /**
     * Render the invitation email for one recipient without sending it
     */
    async getMedicaidRequestEmailPreview(requestParameters: GetMedicaidRequestEmailPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmailPreviewResponse> {
        const response = await this.getMedicaidRequestEmailPreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPortalSession without sending the request
     */
    async getPortalSessionRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/portal/session`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The participant, resident first name and facility for the current session
     */
    async getPortalSessionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortalSessionResponse>> {
        const requestOptions = await this.getPortalSessionRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortalSessionResponseFromJSON(jsonValue));
    }

    /**
     * The participant, resident first name and facility for the current session
     */
    async getPortalSession(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortalSessionResponse> {
        const response = await this.getPortalSessionRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getStaffMedicaidDocumentDownload without sending the request
     */
    async getStaffMedicaidDocumentDownloadRequestOpts(requestParameters: GetStaffMedicaidDocumentDownloadRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['filePosition'] == null) {
            throw new runtime.RequiredError(
                'filePosition',
                'Required parameter "filePosition" was null or undefined when calling getStaffMedicaidDocumentDownload().'
            );
        }

        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling getStaffMedicaidDocumentDownload().'
            );
        }

        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling getStaffMedicaidDocumentDownload().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filePosition'] != null) {
            queryParameters['file_position'] = requestParameters['filePosition'];
        }

        if (requestParameters['variant'] != null) {
            queryParameters['variant'] = requestParameters['variant'];
        }

        if (requestParameters['disposition'] != null) {
            queryParameters['disposition'] = requestParameters['disposition'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/medicaid-cases/{caseId}/documents/{documentId}/download`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace('{documentId}', encodeURIComponent(String(requestParameters['documentId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Five-minute download URL for one file of a document
     */
    async getStaffMedicaidDocumentDownloadRaw(requestParameters: GetStaffMedicaidDocumentDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentDownloadResponse>> {
        const requestOptions = await this.getStaffMedicaidDocumentDownloadRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentDownloadResponseFromJSON(jsonValue));
    }

    /**
     * Five-minute download URL for one file of a document
     */
    async getStaffMedicaidDocumentDownload(requestParameters: GetStaffMedicaidDocumentDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentDownloadResponse> {
        const response = await this.getStaffMedicaidDocumentDownloadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listMedicaidCaseActivity without sending the request
     */
    async listMedicaidCaseActivityRequestOpts(requestParameters: ListMedicaidCaseActivityRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling listMedicaidCaseActivity().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/medicaid-cases/{caseId}/activity`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Audit feed for the case, newest first
     */
    async listMedicaidCaseActivityRaw(requestParameters: ListMedicaidCaseActivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseActivityPageResponse>> {
        const requestOptions = await this.listMedicaidCaseActivityRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseActivityPageResponseFromJSON(jsonValue));
    }

    /**
     * Audit feed for the case, newest first
     */
    async listMedicaidCaseActivity(requestParameters: ListMedicaidCaseActivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseActivityPageResponse> {
        const response = await this.listMedicaidCaseActivityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listMedicaidCases without sending the request
     */
    async listMedicaidCasesRequestOpts(requestParameters: ListMedicaidCasesRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['preset'] != null) {
            queryParameters['preset'] = requestParameters['preset'];
        }

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['ownerUserId'] != null) {
            queryParameters['owner_user_id'] = requestParameters['ownerUserId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/medicaid-cases`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Medicaid Pending cases across the facilities the user can access
     */
    async listMedicaidCasesRaw(requestParameters: ListMedicaidCasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicaidCaseListResponse>> {
        const requestOptions = await this.listMedicaidCasesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MedicaidCaseListResponseFromJSON(jsonValue));
    }

    /**
     * Medicaid Pending cases across the facilities the user can access
     */
    async listMedicaidCases(requestParameters: ListMedicaidCasesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MedicaidCaseListResponse> {
        const response = await this.listMedicaidCasesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listPortalDocuments without sending the request
     */
    async listPortalDocumentsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/portal/documents`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Filename and status of the participant\'s own uploads; never file contents
     */
    async listPortalDocumentsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortalDocumentListResponse>> {
        const requestOptions = await this.listPortalDocumentsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortalDocumentListResponseFromJSON(jsonValue));
    }

    /**
     * Filename and status of the participant\'s own uploads; never file contents
     */
    async listPortalDocuments(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortalDocumentListResponse> {
        const response = await this.listPortalDocumentsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listPortalMessages without sending the request
     */
    async listPortalMessagesRequestOpts(requestParameters: ListPortalMessagesRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'];
        }

        if (requestParameters['before'] != null) {
            queryParameters['before'] = requestParameters['before'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/portal/messages`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The participant\'s private thread with the business office, oldest first
     */
    async listPortalMessagesRaw(requestParameters: ListPortalMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortalMessagePageResponse>> {
        const requestOptions = await this.listPortalMessagesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortalMessagePageResponseFromJSON(jsonValue));
    }

    /**
     * The participant\'s private thread with the business office, oldest first
     */
    async listPortalMessages(requestParameters: ListPortalMessagesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortalMessagePageResponse> {
        const response = await this.listPortalMessagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listPortalRequests without sending the request
     */
    async listPortalRequestsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/portal/requests`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Requests sent to the participant, with the shared checklist status
     */
    async listPortalRequestsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortalRequestListResponse>> {
        const requestOptions = await this.listPortalRequestsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortalRequestListResponseFromJSON(jsonValue));
    }

    /**
     * Requests sent to the participant, with the shared checklist status
     */
    async listPortalRequests(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortalRequestListResponse> {
        const response = await this.listPortalRequestsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listStaffMedicaidDocuments without sending the request
     */
    async listStaffMedicaidDocumentsRequestOpts(requestParameters: ListStaffMedicaidDocumentsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling listStaffMedicaidDocuments().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['requestItemId'] != null) {
            queryParameters['request_item_id'] = requestParameters['requestItemId'];
        }

        if (requestParameters['uncategorized'] != null) {
            queryParameters['uncategorized'] = requestParameters['uncategorized'];
        }

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/medicaid-cases/{caseId}/documents`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Documents on the case, newest first
     */
    async listStaffMedicaidDocumentsRaw(requestParameters: ListStaffMedicaidDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StaffDocumentPageResponse>> {
        const requestOptions = await this.listStaffMedicaidDocumentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StaffDocumentPageResponseFromJSON(jsonValue));
    }

    /**
     * Documents on the case, newest first
     */
    async listStaffMedicaidDocuments(requestParameters: ListStaffMedicaidDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StaffDocumentPageResponse> {
        const response = await this.listStaffMedicaidDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listStaffMedicaidMessages without sending the request
     */
    async listStaffMedicaidMessagesRequestOpts(requestParameters: ListStaffMedicaidMessagesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling listStaffMedicaidMessages().'
            );
        }

        if (requestParameters['participantId'] == null) {
            throw new runtime.RequiredError(
                'participantId',
                'Required parameter "participantId" was null or undefined when calling listStaffMedicaidMessages().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'];
        }

        if (requestParameters['before'] != null) {
            queryParameters['before'] = requestParameters['before'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/medicaid-cases/{caseId}/participants/{participantId}/messages`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace('{participantId}', encodeURIComponent(String(requestParameters['participantId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Private thread with one participant, oldest first
     */
    async listStaffMedicaidMessagesRaw(requestParameters: ListStaffMedicaidMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StaffMessagePageResponse>> {
        const requestOptions = await this.listStaffMedicaidMessagesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StaffMessagePageResponseFromJSON(jsonValue));
    }

    /**
     * Private thread with one participant, oldest first
     */
    async listStaffMedicaidMessages(requestParameters: ListStaffMedicaidMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StaffMessagePageResponse> {
        const response = await this.listStaffMedicaidMessagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for logoutPortalSession without sending the request
     */
    async logoutPortalSessionRequestOpts(requestParameters: LogoutPortalSessionRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/portal/auth/logout`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        };
    }

    /**
     * End the current session; the link keeps working
     */
    async logoutPortalSessionRaw(requestParameters: LogoutPortalSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortalLogoutResponse>> {
        const requestOptions = await this.logoutPortalSessionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortalLogoutResponseFromJSON(jsonValue));
    }

    /**
     * End the current session; the link keeps working
     */
    async logoutPortalSession(requestParameters: LogoutPortalSessionRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortalLogoutResponse> {
        const response = await this.logoutPortalSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for pauseMedicaidRecipientReminders without sending the request
     */
    async pauseMedicaidRecipientRemindersRequestOpts(requestParameters: PauseMedicaidRecipientRemindersRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling pauseMedicaidRecipientReminders().'
            );
        }

        if (requestParameters['requestId'] == null) {
            throw new runtime.RequiredError(
                'requestId',
                'Required parameter "requestId" was null or undefined when calling pauseMedicaidRecipientReminders().'
            );
        }

        if (requestParameters['recipientId'] == null) {
            throw new runtime.RequiredError(
                'recipientId',
                'Required parameter "recipientId" was null or undefined when calling pauseMedicaidRecipientReminders().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/medicaid-cases/{caseId}/requests/{requestId}/recipients/{recipientId}/pause-reminders`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace('{requestId}', encodeURIComponent(String(requestParameters['requestId'])));
        urlPath = urlPath.replace('{recipientId}', encodeURIComponent(String(requestParameters['recipientId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OptionalReasonRequestToJSON(requestParameters['optionalReasonRequest']),
        };
    }

    /**
     * Pause reminders for one recipient
     */
    async pauseMedicaidRecipientRemindersRaw(requestParameters: PauseMedicaidRecipientRemindersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StaffRequestRecipientResponse>> {
        const requestOptions = await this.pauseMedicaidRecipientRemindersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StaffRequestRecipientResponseFromJSON(jsonValue));
    }

    /**
     * Pause reminders for one recipient
     */
    async pauseMedicaidRecipientReminders(requestParameters: PauseMedicaidRecipientRemindersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StaffRequestRecipientResponse> {
        const response = await this.pauseMedicaidRecipientRemindersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for rejectStaffMedicaidDocument without sending the request
     */
    async rejectStaffMedicaidDocumentRequestOpts(requestParameters: RejectStaffMedicaidDocumentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling rejectStaffMedicaidDocument().'
            );
        }

        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling rejectStaffMedicaidDocument().'
            );
        }

        if (requestParameters['rejectDocumentRequest'] == null) {
            throw new runtime.RequiredError(
                'rejectDocumentRequest',
                'Required parameter "rejectDocumentRequest" was null or undefined when calling rejectStaffMedicaidDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/medicaid-cases/{caseId}/documents/{documentId}/reject`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace('{documentId}', encodeURIComponent(String(requestParameters['documentId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RejectDocumentRequestToJSON(requestParameters['rejectDocumentRequest']),
        };
    }

    /**
     * Ask for Another Look; participant_rejection_reason is shown to the uploader as the item note
     */
    async rejectStaffMedicaidDocumentRaw(requestParameters: RejectStaffMedicaidDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StaffDocumentResponse>> {
        const requestOptions = await this.rejectStaffMedicaidDocumentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StaffDocumentResponseFromJSON(jsonValue));
    }

    /**
     * Ask for Another Look; participant_rejection_reason is shown to the uploader as the item note
     */
    async rejectStaffMedicaidDocument(requestParameters: RejectStaffMedicaidDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StaffDocumentResponse> {
        const response = await this.rejectStaffMedicaidDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for removeMedicaidRequestRecipient without sending the request
     */
    async removeMedicaidRequestRecipientRequestOpts(requestParameters: RemoveMedicaidRequestRecipientRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling removeMedicaidRequestRecipient().'
            );
        }

        if (requestParameters['requestId'] == null) {
            throw new runtime.RequiredError(
                'requestId',
                'Required parameter "requestId" was null or undefined when calling removeMedicaidRequestRecipient().'
            );
        }

        if (requestParameters['recipientId'] == null) {
            throw new runtime.RequiredError(
                'recipientId',
                'Required parameter "recipientId" was null or undefined when calling removeMedicaidRequestRecipient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/medicaid-cases/{caseId}/requests/{requestId}/recipients/{recipientId}/remove`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace('{requestId}', encodeURIComponent(String(requestParameters['requestId'])));
        urlPath = urlPath.replace('{recipientId}', encodeURIComponent(String(requestParameters['recipientId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OptionalReasonRequestToJSON(requestParameters['optionalReasonRequest']),
        };
    }

    /**
     * Remove a recipient; blocks their access to the request and cancels future sends, keeping their documents
     */
    async removeMedicaidRequestRecipientRaw(requestParameters: RemoveMedicaidRequestRecipientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StaffRequestRecipientResponse>> {
        const requestOptions = await this.removeMedicaidRequestRecipientRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StaffRequestRecipientResponseFromJSON(jsonValue));
    }

    /**
     * Remove a recipient; blocks their access to the request and cancels future sends, keeping their documents
     */
    async removeMedicaidRequestRecipient(requestParameters: RemoveMedicaidRequestRecipientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StaffRequestRecipientResponse> {
        const response = await this.removeMedicaidRequestRecipientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for renewMedicaidParticipantAccess without sending the request
     */
    async renewMedicaidParticipantAccessRequestOpts(requestParameters: RenewMedicaidParticipantAccessRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling renewMedicaidParticipantAccess().'
            );
        }

        if (requestParameters['participantId'] == null) {
            throw new runtime.RequiredError(
                'participantId',
                'Required parameter "participantId" was null or undefined when calling renewMedicaidParticipantAccess().'
            );
        }

        if (requestParameters['renewAccessRequest'] == null) {
            throw new runtime.RequiredError(
                'renewAccessRequest',
                'Required parameter "renewAccessRequest" was null or undefined when calling renewMedicaidParticipantAccess().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/medicaid-cases/{caseId}/participants/{participantId}/renew-access`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace('{participantId}', encodeURIComponent(String(requestParameters['participantId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RenewAccessRequestToJSON(requestParameters['renewAccessRequest']),
        };
    }

    /**
     * Reconfirm the contact and start a new access period
     */
    async renewMedicaidParticipantAccessRaw(requestParameters: RenewMedicaidParticipantAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StaffParticipantResponse>> {
        const requestOptions = await this.renewMedicaidParticipantAccessRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StaffParticipantResponseFromJSON(jsonValue));
    }

    /**
     * Reconfirm the contact and start a new access period
     */
    async renewMedicaidParticipantAccess(requestParameters: RenewMedicaidParticipantAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StaffParticipantResponse> {
        const response = await this.renewMedicaidParticipantAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for reopenMedicaidCase without sending the request
     */
    async reopenMedicaidCaseRequestOpts(requestParameters: ReopenMedicaidCaseRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling reopenMedicaidCase().'
            );
        }

        if (requestParameters['revisionReasonRequest'] == null) {
            throw new runtime.RequiredError(
                'revisionReasonRequest',
                'Required parameter "revisionReasonRequest" was null or undefined when calling reopenMedicaidCase().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/medicaid-cases/{caseId}/reopen`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RevisionReasonRequestToJSON(requestParameters['revisionReasonRequest']),
        };
    }

    /**
     * Reopen a closed case; new links must be sent
     */
    async reopenMedicaidCaseRaw(requestParameters: ReopenMedicaidCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicaidCaseResponse>> {
        const requestOptions = await this.reopenMedicaidCaseRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MedicaidCaseResponseFromJSON(jsonValue));
    }

    /**
     * Reopen a closed case; new links must be sent
     */
    async reopenMedicaidCase(requestParameters: ReopenMedicaidCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MedicaidCaseResponse> {
        const response = await this.reopenMedicaidCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for resumeMedicaidRecipientReminders without sending the request
     */
    async resumeMedicaidRecipientRemindersRequestOpts(requestParameters: ResumeMedicaidRecipientRemindersRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling resumeMedicaidRecipientReminders().'
            );
        }

        if (requestParameters['requestId'] == null) {
            throw new runtime.RequiredError(
                'requestId',
                'Required parameter "requestId" was null or undefined when calling resumeMedicaidRecipientReminders().'
            );
        }

        if (requestParameters['recipientId'] == null) {
            throw new runtime.RequiredError(
                'recipientId',
                'Required parameter "recipientId" was null or undefined when calling resumeMedicaidRecipientReminders().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/medicaid-cases/{caseId}/requests/{requestId}/recipients/{recipientId}/resume-reminders`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace('{requestId}', encodeURIComponent(String(requestParameters['requestId'])));
        urlPath = urlPath.replace('{recipientId}', encodeURIComponent(String(requestParameters['recipientId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        };
    }

    /**
     * Resume reminders for one recipient
     */
    async resumeMedicaidRecipientRemindersRaw(requestParameters: ResumeMedicaidRecipientRemindersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StaffRequestRecipientResponse>> {
        const requestOptions = await this.resumeMedicaidRecipientRemindersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StaffRequestRecipientResponseFromJSON(jsonValue));
    }

    /**
     * Resume reminders for one recipient
     */
    async resumeMedicaidRecipientReminders(requestParameters: ResumeMedicaidRecipientRemindersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StaffRequestRecipientResponse> {
        const response = await this.resumeMedicaidRecipientRemindersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for revokeMedicaidParticipantAccess without sending the request
     */
    async revokeMedicaidParticipantAccessRequestOpts(requestParameters: RevokeMedicaidParticipantAccessRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling revokeMedicaidParticipantAccess().'
            );
        }

        if (requestParameters['participantId'] == null) {
            throw new runtime.RequiredError(
                'participantId',
                'Required parameter "participantId" was null or undefined when calling revokeMedicaidParticipantAccess().'
            );
        }

        if (requestParameters['reasonRequest'] == null) {
            throw new runtime.RequiredError(
                'reasonRequest',
                'Required parameter "reasonRequest" was null or undefined when calling revokeMedicaidParticipantAccess().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/medicaid-cases/{caseId}/participants/{participantId}/revoke-access`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace('{participantId}', encodeURIComponent(String(requestParameters['participantId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReasonRequestToJSON(requestParameters['reasonRequest']),
        };
    }

    /**
     * Revoke every link and session for the participant; their documents and messages are kept
     */
    async revokeMedicaidParticipantAccessRaw(requestParameters: RevokeMedicaidParticipantAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StaffParticipantResponse>> {
        const requestOptions = await this.revokeMedicaidParticipantAccessRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StaffParticipantResponseFromJSON(jsonValue));
    }

    /**
     * Revoke every link and session for the participant; their documents and messages are kept
     */
    async revokeMedicaidParticipantAccess(requestParameters: RevokeMedicaidParticipantAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StaffParticipantResponse> {
        const response = await this.revokeMedicaidParticipantAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for sendMedicaidRecipientReminder without sending the request
     */
    async sendMedicaidRecipientReminderRequestOpts(requestParameters: SendMedicaidRecipientReminderRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling sendMedicaidRecipientReminder().'
            );
        }

        if (requestParameters['requestId'] == null) {
            throw new runtime.RequiredError(
                'requestId',
                'Required parameter "requestId" was null or undefined when calling sendMedicaidRecipientReminder().'
            );
        }

        if (requestParameters['recipientId'] == null) {
            throw new runtime.RequiredError(
                'recipientId',
                'Required parameter "recipientId" was null or undefined when calling sendMedicaidRecipientReminder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/medicaid-cases/{caseId}/requests/{requestId}/recipients/{recipientId}/send-reminder`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace('{requestId}', encodeURIComponent(String(requestParameters['requestId'])));
        urlPath = urlPath.replace('{recipientId}', encodeURIComponent(String(requestParameters['recipientId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        };
    }

    /**
     * Send Reminder; queue a reminder email to one recipient now
     */
    async sendMedicaidRecipientReminderRaw(requestParameters: SendMedicaidRecipientReminderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StaffRequestRecipientResponse>> {
        const requestOptions = await this.sendMedicaidRecipientReminderRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StaffRequestRecipientResponseFromJSON(jsonValue));
    }

    /**
     * Send Reminder; queue a reminder email to one recipient now
     */
    async sendMedicaidRecipientReminder(requestParameters: SendMedicaidRecipientReminderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StaffRequestRecipientResponse> {
        const response = await this.sendMedicaidRecipientReminderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for sendMedicaidRequest without sending the request
     */
    async sendMedicaidRequestRequestOpts(requestParameters: SendMedicaidRequestRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling sendMedicaidRequest().'
            );
        }

        if (requestParameters['requestId'] == null) {
            throw new runtime.RequiredError(
                'requestId',
                'Required parameter "requestId" was null or undefined when calling sendMedicaidRequest().'
            );
        }

        if (requestParameters['expectedRevisionRequest'] == null) {
            throw new runtime.RequiredError(
                'expectedRevisionRequest',
                'Required parameter "expectedRevisionRequest" was null or undefined when calling sendMedicaidRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/medicaid-cases/{caseId}/requests/{requestId}/send`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace('{requestId}', encodeURIComponent(String(requestParameters['requestId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExpectedRevisionRequestToJSON(requestParameters['expectedRevisionRequest']),
        };
    }

    /**
     * Email a link to every active recipient; blocked until the verification DOB is confirmed
     */
    async sendMedicaidRequestRaw(requestParameters: SendMedicaidRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StaffRequestResponse>> {
        const requestOptions = await this.sendMedicaidRequestRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StaffRequestResponseFromJSON(jsonValue));
    }

    /**
     * Email a link to every active recipient; blocked until the verification DOB is confirmed
     */
    async sendMedicaidRequest(requestParameters: SendMedicaidRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StaffRequestResponse> {
        const response = await this.sendMedicaidRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for sendPortalMessage without sending the request
     */
    async sendPortalMessageRequestOpts(requestParameters: SendPortalMessageRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['portalMessageInput'] == null) {
            throw new runtime.RequiredError(
                'portalMessageInput',
                'Required parameter "portalMessageInput" was null or undefined when calling sendPortalMessage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/portal/messages`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PortalMessageInputToJSON(requestParameters['portalMessageInput']),
        };
    }

    /**
     * Send a message to the business office
     */
    async sendPortalMessageRaw(requestParameters: SendPortalMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortalMessageResponse>> {
        const requestOptions = await this.sendPortalMessageRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortalMessageResponseFromJSON(jsonValue));
    }

    /**
     * Send a message to the business office
     */
    async sendPortalMessage(requestParameters: SendPortalMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortalMessageResponse> {
        const response = await this.sendPortalMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for sendStaffMedicaidMessage without sending the request
     */
    async sendStaffMedicaidMessageRequestOpts(requestParameters: SendStaffMedicaidMessageRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling sendStaffMedicaidMessage().'
            );
        }

        if (requestParameters['participantId'] == null) {
            throw new runtime.RequiredError(
                'participantId',
                'Required parameter "participantId" was null or undefined when calling sendStaffMedicaidMessage().'
            );
        }

        if (requestParameters['staffMessageInput'] == null) {
            throw new runtime.RequiredError(
                'staffMessageInput',
                'Required parameter "staffMessageInput" was null or undefined when calling sendStaffMedicaidMessage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/medicaid-cases/{caseId}/participants/{participantId}/messages`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace('{participantId}', encodeURIComponent(String(requestParameters['participantId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StaffMessageInputToJSON(requestParameters['staffMessageInput']),
        };
    }

    /**
     * Reply to a participant in their private thread
     */
    async sendStaffMedicaidMessageRaw(requestParameters: SendStaffMedicaidMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StaffMessageResponse>> {
        const requestOptions = await this.sendStaffMedicaidMessageRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StaffMessageResponseFromJSON(jsonValue));
    }

    /**
     * Reply to a participant in their private thread
     */
    async sendStaffMedicaidMessage(requestParameters: SendStaffMedicaidMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StaffMessageResponse> {
        const response = await this.sendStaffMedicaidMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for startPortalAuth without sending the request
     */
    async startPortalAuthRequestOpts(requestParameters: StartPortalAuthRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['portalLinkTokenRequest'] == null) {
            throw new runtime.RequiredError(
                'portalLinkTokenRequest',
                'Required parameter "portalLinkTokenRequest" was null or undefined when calling startPortalAuth().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/portal/auth/start`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PortalLinkTokenRequestToJSON(requestParameters['portalLinkTokenRequest']),
        };
    }

    /**
     * Check a link token before asking for the date of birth; does not create a session
     */
    async startPortalAuthRaw(requestParameters: StartPortalAuthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortalAuthStartResponse>> {
        const requestOptions = await this.startPortalAuthRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortalAuthStartResponseFromJSON(jsonValue));
    }

    /**
     * Check a link token before asking for the date of birth; does not create a session
     */
    async startPortalAuth(requestParameters: StartPortalAuthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortalAuthStartResponse> {
        const response = await this.startPortalAuthRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for submitPortalItemResponse without sending the request
     */
    async submitPortalItemResponseRequestOpts(requestParameters: SubmitPortalItemResponseRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['itemId'] == null) {
            throw new runtime.RequiredError(
                'itemId',
                'Required parameter "itemId" was null or undefined when calling submitPortalItemResponse().'
            );
        }

        if (requestParameters['portalItemResponseInput'] == null) {
            throw new runtime.RequiredError(
                'portalItemResponseInput',
                'Required parameter "portalItemResponseInput" was null or undefined when calling submitPortalItemResponse().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/portal/items/{itemId}/response`;
        urlPath = urlPath.replace('{itemId}', encodeURIComponent(String(requestParameters['itemId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PortalItemResponseInputToJSON(requestParameters['portalItemResponseInput']),
        };
    }

    /**
     * I Don\'t Have This; record why the participant can\'t send an item
     */
    async submitPortalItemResponseRaw(requestParameters: SubmitPortalItemResponseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortalRequestItemResponse>> {
        const requestOptions = await this.submitPortalItemResponseRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortalRequestItemResponseFromJSON(jsonValue));
    }

    /**
     * I Don\'t Have This; record why the participant can\'t send an item
     */
    async submitPortalItemResponse(requestParameters: SubmitPortalItemResponseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortalRequestItemResponse> {
        const response = await this.submitPortalItemResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateMedicaidCase without sending the request
     */
    async updateMedicaidCaseRequestOpts(requestParameters: UpdateMedicaidCaseOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling updateMedicaidCase().'
            );
        }

        if (requestParameters['updateMedicaidCaseRequest'] == null) {
            throw new runtime.RequiredError(
                'updateMedicaidCaseRequest',
                'Required parameter "updateMedicaidCaseRequest" was null or undefined when calling updateMedicaidCase().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/medicaid-cases/{caseId}`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateMedicaidCaseRequestToJSON(requestParameters['updateMedicaidCaseRequest']),
        };
    }

    /**
     * Change the case owner or pause/resume the case
     */
    async updateMedicaidCaseRaw(requestParameters: UpdateMedicaidCaseOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicaidCaseResponse>> {
        const requestOptions = await this.updateMedicaidCaseRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MedicaidCaseResponseFromJSON(jsonValue));
    }

    /**
     * Change the case owner or pause/resume the case
     */
    async updateMedicaidCase(requestParameters: UpdateMedicaidCaseOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MedicaidCaseResponse> {
        const response = await this.updateMedicaidCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateMedicaidParticipant without sending the request
     */
    async updateMedicaidParticipantRequestOpts(requestParameters: UpdateMedicaidParticipantRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling updateMedicaidParticipant().'
            );
        }

        if (requestParameters['participantId'] == null) {
            throw new runtime.RequiredError(
                'participantId',
                'Required parameter "participantId" was null or undefined when calling updateMedicaidParticipant().'
            );
        }

        if (requestParameters['updateParticipantRequest'] == null) {
            throw new runtime.RequiredError(
                'updateParticipantRequest',
                'Required parameter "updateParticipantRequest" was null or undefined when calling updateMedicaidParticipant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/medicaid-cases/{caseId}/participants/{participantId}`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace('{participantId}', encodeURIComponent(String(requestParameters['participantId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateParticipantRequestToJSON(requestParameters['updateParticipantRequest']),
        };
    }

    /**
     * Update a participant; changing the email revokes every earlier link and session
     */
    async updateMedicaidParticipantRaw(requestParameters: UpdateMedicaidParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StaffParticipantResponse>> {
        const requestOptions = await this.updateMedicaidParticipantRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StaffParticipantResponseFromJSON(jsonValue));
    }

    /**
     * Update a participant; changing the email revokes every earlier link and session
     */
    async updateMedicaidParticipant(requestParameters: UpdateMedicaidParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StaffParticipantResponse> {
        const response = await this.updateMedicaidParticipantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateMedicaidRequest without sending the request
     */
    async updateMedicaidRequestRequestOpts(requestParameters: UpdateMedicaidRequestRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling updateMedicaidRequest().'
            );
        }

        if (requestParameters['requestId'] == null) {
            throw new runtime.RequiredError(
                'requestId',
                'Required parameter "requestId" was null or undefined when calling updateMedicaidRequest().'
            );
        }

        if (requestParameters['updateRequestRequest'] == null) {
            throw new runtime.RequiredError(
                'updateRequestRequest',
                'Required parameter "updateRequestRequest" was null or undefined when calling updateMedicaidRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/medicaid-cases/{caseId}/requests/{requestId}`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace('{requestId}', encodeURIComponent(String(requestParameters['requestId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateRequestRequestToJSON(requestParameters['updateRequestRequest']),
        };
    }

    /**
     * Edit the request wording, due date or reminder settings
     */
    async updateMedicaidRequestRaw(requestParameters: UpdateMedicaidRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StaffRequestResponse>> {
        const requestOptions = await this.updateMedicaidRequestRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StaffRequestResponseFromJSON(jsonValue));
    }

    /**
     * Edit the request wording, due date or reminder settings
     */
    async updateMedicaidRequest(requestParameters: UpdateMedicaidRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StaffRequestResponse> {
        const response = await this.updateMedicaidRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateMedicaidRequestItem without sending the request
     */
    async updateMedicaidRequestItemRequestOpts(requestParameters: UpdateMedicaidRequestItemRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling updateMedicaidRequestItem().'
            );
        }

        if (requestParameters['itemId'] == null) {
            throw new runtime.RequiredError(
                'itemId',
                'Required parameter "itemId" was null or undefined when calling updateMedicaidRequestItem().'
            );
        }

        if (requestParameters['updateRequestItemRequest'] == null) {
            throw new runtime.RequiredError(
                'updateRequestItemRequest',
                'Required parameter "updateRequestItemRequest" was null or undefined when calling updateMedicaidRequestItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/medicaid-cases/{caseId}/items/{itemId}`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace('{itemId}', encodeURIComponent(String(requestParameters['itemId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateRequestItemRequestToJSON(requestParameters['updateRequestItemRequest']),
        };
    }

    /**
     * Edit an item, assign it, set its due date or mark it fulfilled, needed or withdrawn
     */
    async updateMedicaidRequestItemRaw(requestParameters: UpdateMedicaidRequestItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StaffRequestItemResponse>> {
        const requestOptions = await this.updateMedicaidRequestItemRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StaffRequestItemResponseFromJSON(jsonValue));
    }

    /**
     * Edit an item, assign it, set its due date or mark it fulfilled, needed or withdrawn
     */
    async updateMedicaidRequestItem(requestParameters: UpdateMedicaidRequestItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StaffRequestItemResponse> {
        const response = await this.updateMedicaidRequestItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updatePortalReadCursor without sending the request
     */
    async updatePortalReadCursorRequestOpts(requestParameters: UpdatePortalReadCursorRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['readCursorRequest'] == null) {
            throw new runtime.RequiredError(
                'readCursorRequest',
                'Required parameter "readCursorRequest" was null or undefined when calling updatePortalReadCursor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/portal/read-cursor`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReadCursorRequestToJSON(requestParameters['readCursorRequest']),
        };
    }

    /**
     * Advance the participant\'s read marker
     */
    async updatePortalReadCursorRaw(requestParameters: UpdatePortalReadCursorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReadCursorResponse>> {
        const requestOptions = await this.updatePortalReadCursorRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReadCursorResponseFromJSON(jsonValue));
    }

    /**
     * Advance the participant\'s read marker
     */
    async updatePortalReadCursor(requestParameters: UpdatePortalReadCursorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReadCursorResponse> {
        const response = await this.updatePortalReadCursorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateStaffMedicaidDocument without sending the request
     */
    async updateStaffMedicaidDocumentRequestOpts(requestParameters: UpdateStaffMedicaidDocumentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling updateStaffMedicaidDocument().'
            );
        }

        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling updateStaffMedicaidDocument().'
            );
        }

        if (requestParameters['updateDocumentRequest'] == null) {
            throw new runtime.RequiredError(
                'updateDocumentRequest',
                'Required parameter "updateDocumentRequest" was null or undefined when calling updateStaffMedicaidDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/medicaid-cases/{caseId}/documents/{documentId}`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace('{documentId}', encodeURIComponent(String(requestParameters['documentId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDocumentRequestToJSON(requestParameters['updateDocumentRequest']),
        };
    }

    /**
     * Link a document to checklist items or rename it
     */
    async updateStaffMedicaidDocumentRaw(requestParameters: UpdateStaffMedicaidDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StaffDocumentResponse>> {
        const requestOptions = await this.updateStaffMedicaidDocumentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StaffDocumentResponseFromJSON(jsonValue));
    }

    /**
     * Link a document to checklist items or rename it
     */
    async updateStaffMedicaidDocument(requestParameters: UpdateStaffMedicaidDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StaffDocumentResponse> {
        const response = await this.updateStaffMedicaidDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for withdrawMedicaidRequest without sending the request
     */
    async withdrawMedicaidRequestRequestOpts(requestParameters: WithdrawMedicaidRequestRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling withdrawMedicaidRequest().'
            );
        }

        if (requestParameters['requestId'] == null) {
            throw new runtime.RequiredError(
                'requestId',
                'Required parameter "requestId" was null or undefined when calling withdrawMedicaidRequest().'
            );
        }

        if (requestParameters['revisionReasonRequest'] == null) {
            throw new runtime.RequiredError(
                'revisionReasonRequest',
                'Required parameter "revisionReasonRequest" was null or undefined when calling withdrawMedicaidRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/medicaid-cases/{caseId}/requests/{requestId}/withdraw`;
        urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace('{requestId}', encodeURIComponent(String(requestParameters['requestId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RevisionReasonRequestToJSON(requestParameters['revisionReasonRequest']),
        };
    }

    /**
     * Withdraw the request and cancel its pending sends
     */
    async withdrawMedicaidRequestRaw(requestParameters: WithdrawMedicaidRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StaffRequestResponse>> {
        const requestOptions = await this.withdrawMedicaidRequestRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StaffRequestResponseFromJSON(jsonValue));
    }

    /**
     * Withdraw the request and cancel its pending sends
     */
    async withdrawMedicaidRequest(requestParameters: WithdrawMedicaidRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StaffRequestResponse> {
        const response = await this.withdrawMedicaidRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for withdrawPortalItemResponse without sending the request
     */
    async withdrawPortalItemResponseRequestOpts(requestParameters: WithdrawPortalItemResponseRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['itemId'] == null) {
            throw new runtime.RequiredError(
                'itemId',
                'Required parameter "itemId" was null or undefined when calling withdrawPortalItemResponse().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/portal/items/{itemId}/response`;
        urlPath = urlPath.replace('{itemId}', encodeURIComponent(String(requestParameters['itemId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Undo the participant\'s \"I Don\'t Have This\" response
     */
    async withdrawPortalItemResponseRaw(requestParameters: WithdrawPortalItemResponseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortalRequestItemResponse>> {
        const requestOptions = await this.withdrawPortalItemResponseRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortalRequestItemResponseFromJSON(jsonValue));
    }

    /**
     * Undo the participant\'s \"I Don\'t Have This\" response
     */
    async withdrawPortalItemResponse(requestParameters: WithdrawPortalItemResponseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortalRequestItemResponse> {
        const response = await this.withdrawPortalItemResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetStaffMedicaidDocumentDownloadVariantEnum = {
    Original: 'original',
    Pdf: 'pdf',
} as const;
export type GetStaffMedicaidDocumentDownloadVariantEnum = typeof GetStaffMedicaidDocumentDownloadVariantEnum[keyof typeof GetStaffMedicaidDocumentDownloadVariantEnum];
/**
 * @export
 */
export const GetStaffMedicaidDocumentDownloadDispositionEnum = {
    Inline: 'inline',
    Attachment: 'attachment',
} as const;
export type GetStaffMedicaidDocumentDownloadDispositionEnum = typeof GetStaffMedicaidDocumentDownloadDispositionEnum[keyof typeof GetStaffMedicaidDocumentDownloadDispositionEnum];
/**
 * @export
 */
export const ListStaffMedicaidDocumentsUncategorizedEnum = {
    True: 'true',
    False: 'false',
} as const;
export type ListStaffMedicaidDocumentsUncategorizedEnum = typeof ListStaffMedicaidDocumentsUncategorizedEnum[keyof typeof ListStaffMedicaidDocumentsUncategorizedEnum];
